import React from 'react';
import { ModalTabs } from '../../types';
import AllDisplay from './AllDisplay';
import ResponsesDisplay from './ResponsesDisplay';
import UploadsDisplay from './UploadsDisplay';
import SocialDisplay from './SocialDisplay';
import { usePublishSelectModalContext } from '../../../../Contexts/PublishSelectModalContext';

export interface AssetPageProps {
  perPage?: number;
  scrollContainerRef?: React.RefObject<HTMLElement>;
  selectedTab: string;
}

export default function Content({
  selectedTab,
  scrollContainerRef,
}: AssetPageProps) {
  const { isItemSelectDisabled } = usePublishSelectModalContext()!;

  const props = {
    scrollContainerRef,
    isItemSelectDisabled,
  };

  switch (selectedTab) {
    case ModalTabs.Responses:
      return <ResponsesDisplay {...props} />;
    case ModalTabs.Social:
      return <SocialDisplay {...props} />;
    case ModalTabs.Uploads:
      return <UploadsDisplay {...props} />;
    default:
      return <AllDisplay {...props} />;
  }
}
